import {
  callDownloadImages,
  callGetAppVersion,
  callGetLocationPermissionStatus,
  callGetNotificationPermissionStatus,
  callGetScheduledNotificationConfig,
  callYqbGetAppNetUserId,
  callYqbGetAppUserId,
  isCallableGetAppVersion,
} from "./publisher";
import {
  GetAppUserIdData,
  GetAppVersionData,
  GetLocationPermissionStatusData,
  GetNetUserIdData,
  GetNotificationPermissionStatusData,
  GetScheduledNotificationConfigData,
  ImageDownloadStatusData,
  setYqbSendAppNetUserIdHandler,
  setYqbSendAppUserIdHandler,
  setYqbSendAppVersionHandler,
  setYqbSendImageDownloadStatusHandler,
  setYqbSendLocationPermissionStatusHandler,
  setYqbSendNotificationPermissionStatusHandler,
  setYqbSendScheduledNotificationConfigHandler,
  SubscribeHandler,
} from "./subscriber";

export const getAppVersion = (handler: SubscribeHandler<GetAppVersionData>, errorHandler?: () => void) => {
  setYqbSendAppVersionHandler(handler, errorHandler);

  callGetAppVersion();
};

export const getIsInMccmApp = (handler: SubscribeHandler<boolean>) => {
  if (!isCallableGetAppVersion()) {
    handler(false);
    return;
  }
  setYqbSendAppVersionHandler(
    (_) => handler(true),
    () => handler(false)
  );

  callGetAppVersion();
};

export const getAppNetUserIdFromApp = (handler: SubscribeHandler<GetNetUserIdData>, errorHandler?: () => void) => {
  // yqbSendAppNetUserIdがアプリから呼ばれた時のhandlerを設定する
  setYqbSendAppNetUserIdHandler(handler, errorHandler);

  // トリガーとして呼び出す
  callYqbGetAppNetUserId({});
};

export const getAppUserIdFromApp = (handler: SubscribeHandler<GetAppUserIdData>, errorHandler?: () => void) => {
  setYqbSendAppUserIdHandler(handler, errorHandler);

  callYqbGetAppUserId({});
};

export const getNotificationPermissionStatus = (
  handler: SubscribeHandler<GetNotificationPermissionStatusData>,
  errorHandler?: () => void
) => {
  setYqbSendNotificationPermissionStatusHandler(handler, errorHandler);

  callGetNotificationPermissionStatus();
};

export const getAppMedicineAlarmNotificationConfig = (
  handler: SubscribeHandler<GetScheduledNotificationConfigData>,
  errorHandler?: () => void
) => {
  setYqbSendScheduledNotificationConfigHandler(handler, errorHandler);

  callGetScheduledNotificationConfig();
};

export const getAppLocationPermissionStatus = (
  handler: SubscribeHandler<GetLocationPermissionStatusData>,
  errorHandler?: () => void
) => {
  setYqbSendLocationPermissionStatusHandler(handler, errorHandler);

  callGetLocationPermissionStatus();
};

export const downloadImages = (
  imageUrls: string[],
  handler: SubscribeHandler<ImageDownloadStatusData>,
  errorHandler?: () => void
) => {
  setYqbSendImageDownloadStatusHandler(handler, errorHandler);

  callDownloadImages(imageUrls);
};
